import type { MeResponse } from "@/api/types";

/** First path segments that are app pages, not organisation slugs. */
export const RESERVED_TOP = new Set(["", "admin", "account", "design-system", "welcome", "privacy", "terms"]);

/** The organisation the user is looking at: from the URL, else their only organisation. */
export function currentOrgSlug(pathname: string, me: MeResponse | undefined): string | null {
  const first = pathname.split("/")[1] ?? "";
  if (!RESERVED_TOP.has(first)) return first;
  if (me && !me.is_staff && me.memberships.length === 1) return me.memberships[0]?.organisation_slug ?? null;
  return null;
}

/** Where "Home" goes: the attention page of the only organisation, or the all-organisations page. */
export function homePath(me: MeResponse | undefined): string {
  if (me && !me.is_staff && me.memberships.length === 1) return `/${me.memberships[0]?.organisation_slug ?? ""}`;
  return "/";
}
